import { getRuleTypeName, getRuleDesc } from '@Bill/utils'
import { getSuggestRuleConfig } from '@Bill/constants'

import i18n from '@/locales'

export const getResNameTableColumn = ({ field = 'name' } = {}) => {
  return {
    field,
    title: i18n.t('bill.text_72'),
    minWidth: 70,
    showOverflow: 'title',
    slots: {
      default: ({ row }, h) => {
        return [
          <list-body-cell-wrap copy field={field} row={row} />,
        ]
      },
    },
  }
}

export const getTypeTableColumn = () => {
  return {
    field: 'type',
    title: i18n.t('bill.text_212'),
    minWidth: 70,
    showOverflow: 'title',
    formatter: ({ row }) => {
      return getRuleTypeName(row.type) || '-'
    },
  }
}

export const getMonitorConfigTableColumn = () => {
  return {
    field: 'monitor_config',
    title: i18n.t('bill.text_174'),
    minWidth: 70,
    showOverflow: 'title',
    formatter: ({ row }) => {
      const rules = JSON.stringify(row.monitor_config)
      return rules || '-'
    },
  }
}

export const getSuggestRuleTableColumn = () => {
  return {
    field: 'suggest_rule',
    title: i18n.t('meter.suggestion_rule'),
    minWidth: 70,
    showOverflow: 'title',
    formatter: ({ row }) => {
      let type = ''
      if (row.type.includes('UP_DOWN_')) {
        type = 2
      } else if (row.type.includes('_UNUSED')) {
        type = 1
      } else {
        type = 3
      }
      const setting = row.rule_setting?.scale_rule ? row.rule_setting?.scale_rule[0] : {}
      return getSuggestRuleConfig({
        type,
        resource_type: row.res_type,
        time_from: row.time_from,
        adjust_ratio: row.adjust_ratio,
        ...setting,
      }).rule
    },
  }
}

export const getSuggestTableColumn = () => {
  return {
    field: 'suggest_rule',
    title: i18n.t('meter.accuracy_method'),
    minWidth: 70,
    showOverflow: 'title',
    formatter: ({ row }) => {
      let type = ''
      if (row.type.includes('UP_DOWN_')) {
        type = 2
      } else if (row.type.includes('_UNUSED')) {
        type = 1
      } else {
        type = 3
      }
      const setting = row.rule_setting?.scale_rule ? row.rule_setting?.scale_rule[0] : {}
      return getSuggestRuleConfig({
        type,
        resource_type: row.res_type,
        time_from: row.time_from,
        adjust_ratio: row.adjust_ratio,
        ...setting,
      }).method
    },
  }
}

export const getProblemTableColumn = () => {
  return {
    field: 'problem',
    title: i18n.t('bill.text_187'),
    minWidth: 90,
    showOverflow: 'title',
    slots: {
      default: ({ row }, h) => {
        if (row.problem && row.problem.length > 0) {
          return row.problem.map(v => {
            if (!v.type || !v.description) return '-'
            return <div class="text-truncate" title={`${v.type}:${v.description}`}>{`${v.type}:${v.description}`}</div>
          })
        }
        return []
      },
    },
  }
}

export const getRuleNameTableColumn = ({ field = 'rule_name' } = {}) => {
  return {
    field,
    title: i18n.t('bill.text_174'),
    minWidth: 70,
    showOverflow: 'title',
    slots: {
      default: ({ row }, h) => {
        const ruleDesc = getRuleDesc(row.type, row.monitor_config, row).strategy
        return [
          <div class='text-truncate' title={ ruleDesc }>
            { ruleDesc }
          </div>,
        ]
      },
    },
  }
}
